<template>
    <div class="" style="position: relative;width: 100%;">
        <iframe :src="iframeUrl" width="100%" height="1600px" scrolling="auto" frameborder="0"></iframe>
    </div>
</template>

<script>

import {useRoute} from 'vue-router'
import {ref, onMounted} from 'vue';

export default {
    components: { },
    setup() {

        const route = useRoute();

        const iframeUrl = ref('');


        onMounted(() => {
            iframeUrl.value = route.query.iframeUrl;
        })

        return {
            iframeUrl
        }
    }
}
</script>

<style lang="less" scoped>
@import 'public/static/css/userBaseInfo.less';
</style>

